import React from "react";
import { playStoreUrl } from "../lib/appLinks";
import { cn } from "../lib/utils";

const PlayGlyph = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M3.6 2.2c-.3.2-.5.6-.5 1.1v17.4c0 .5.2.9.5 1.1l9.3-9.8L3.6 2.2z" fill="#00D3FF" />
    <path d="M16.5 8.6L12.9 12l3.6 3.4 4-2.3c.7-.4.7-1.4 0-1.8l-4-2.7z" fill="#FFCE00" />
    <path d="M3.6 2.2l9.3 9.8 3.6-3.4L5.9 1.9c-.9-.5-1.8-.3-2.3.3z" fill="#00F076" />
    <path d="M3.6 21.8c.5.6 1.4.8 2.3.3l10.6-6.7-3.6-3.4-9.3 9.8z" fill="#FF3A44" />
  </svg>
);

export function PlayStoreButton({ placement = "site", className, label = "Pre-registreer op Google Play" }) {
  return (
    <a
      href={playStoreUrl(placement)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="play-store-cta"
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full bg-navy px-6 py-3 font-bold text-white shadow-lg transition-transform hover:scale-[1.02] active:scale-95",
        className
      )}
    >
      <PlayGlyph /> {label}
    </a>
  );
}

export function PlayStoreBanner({ placement = "site", className }) {
  return (
    <div
      data-testid="play-store-banner"
      className={cn(
        "flex flex-col gap-4 rounded-3xl bg-navy p-7 text-white shadow-lg sm:flex-row sm:items-center sm:justify-between",
        className
      )}
    >
      <div>
        <h3 className="font-display text-xl font-bold">Wees er als eerste bij 🎉</h3>
        <p className="mt-1 text-sm text-slate-300">
          Pre-registreer nu op Google Play en krijg een melding zodra de WoningAlert-app live is.
        </p>
      </div>
      <PlayStoreButton placement={placement} className="shrink-0 bg-brandblue hover:bg-brandblue/90" />
    </div>
  );
}
